import style from "./loading-animation.module.css"
import LoadingCircle from "@/components/loading-animation/loading-circle.tsx"
import { cn } from "@/utils/styles.ts"

interface Props {
  customStyle?: React.CSSProperties
  className?: string
}

export const LoadingAnimation: React.FC<Props> = ({
  customStyle,
  className,
}) => {
  return (
    <div
      style={{ ...customStyle }}
      className={cn(style["loading-animation-wrapper"], className)}
    >
      <LoadingCircle />
    </div>
  )
}
